function stopEvent(event, options) {
  if (options?.prevent) {
    event.preventDefault();
  }
  event.stopPropagation();
}

export { stopEvent };
//# sourceMappingURL=event.mjs.map
